export default class UnderwritingCompanyContext {
  constructor(data) {
    this.isRideshareMarket = data?.isRideshareMarket;
  }
}
